import { render } from "./QDemographics.vue?vue&type=template&id=cff8234e&ts=true"
import script from "./QDemographics.vue?vue&type=script&lang=ts"
export * from "./QDemographics.vue?vue&type=script&lang=ts"

import "./QDemographics.vue?vue&type=style&index=0&id=cff8234e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__